import { bankApi, USE_XSRF_HEADER } from '@/api'
import { IEmptyResponse } from '@/domains/CommonDomain'
import {
  IAddFavoriteTransfer,
  IFindAccountOwnerBIFastRequest,
  IFindAccountOwnerBIFastResponse,
  IFindRecentlyFavoriteTransferRequest,
  IFindTransferLimitByTypeRequest,
  IFindTransferLimitByTypeResponse,
  IFindTransferLimitResponse,
  IInquiryFinancialInstitutionResponse,
  IInquiryRecentBookmarkTransferResponse,
  IRemoveFavoriteTransfer,
  IValidateRecentlyFavoriteTransferBIFastRequest,
  IValidateRecentlyFavoriteTransferRequest,
  TransactionDivisionCode,
  TransactionRequestRowCount,
  TransactionRequestType,
} from '@/domains/TransferDomain'

const BASE = '/transfer'

export const fetchTransferLimit = (): Promise<IFindTransferLimitResponse> => {
  return bankApi.post(`${BASE}/transfer-limit`)
}

export const fetchScheduleBookmarkTransfer = (
  wdrwAcctNo: string,
): Promise<IInquiryRecentBookmarkTransferResponse> => {
  const data: IFindRecentlyFavoriteTransferRequest = {
    rowCnt: TransactionRequestRowCount,
    trscDvCd: TransactionDivisionCode.FAVORITE_RECENT,
    trscType: TransactionRequestType.ACCOUNT_NUMBER_ONLY,
    wdrwAcctNo,
  }

  return bankApi.post(`${BASE}/recently-favorite`, data)
}

export const fetchFinancialInstitutionsInstant = (): Promise<IInquiryFinancialInstitutionResponse> => {
  return bankApi.post(`${BASE}/financial-institutions/instant`)
}

export const addFavoriteTransfer = (query: IAddFavoriteTransfer): Promise<IEmptyResponse> => {
  return bankApi.post(`${BASE}/favorite/add`, query, USE_XSRF_HEADER)
}

export const removeFavoriteTransfer = (query: IRemoveFavoriteTransfer): Promise<IEmptyResponse> => {
  return bankApi.post(`${BASE}/favorite/remove`, query, USE_XSRF_HEADER)
}

export const validateFavoriteTransfer = (
  query: IValidateRecentlyFavoriteTransferRequest,
): Promise<IEmptyResponse> => {
  return bankApi.post(`${BASE}/recently-favorite/validate`, query)
}

export const validateBIFastTransfer = (
  query: IValidateRecentlyFavoriteTransferBIFastRequest,
): Promise<IEmptyResponse> => {
  return bankApi.post(`${BASE}/recently-favorite/bi-fast/validate`, query)
}

export const fetchTransferLimitByType = (
  query: IFindTransferLimitByTypeRequest,
): Promise<IFindTransferLimitByTypeResponse> => {
  return bankApi.post(`${BASE}/by-type/transfer-limit`, query)
}

/* 이체타입(BI-Fast) 판별 및 이체타입에 따른 고객정보 조회 */
export const fetchAccountOwnerBiFast = (
  query: IFindAccountOwnerBIFastRequest,
): Promise<IFindAccountOwnerBIFastResponse> => {
  return bankApi.post(`${BASE}/bi-fast/find-account-owner`, query)
}
